import { motion } from "framer-motion";

export const StickyCTA = ({ event }) => {
  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-acid/30 bg-black/90 backdrop-blur-xl"
      data-testid="sticky-cta-bar"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 truncate">
            {event.city} · {event.dateLabel}
          </p>
          <p className="font-display font-bold text-acid text-sm sm:text-base">
            {event.priceLabel}
          </p>
        </div>
        <a
          href={event.ticketUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta-btn"
          className="shrink-0 bg-acid text-black font-display font-extrabold uppercase tracking-wide text-xs sm:text-sm px-5 sm:px-7 py-3 hover:bg-white transition-colors duration-300 animate-pulse-glow"
        >
          Get Tickets
        </a>
      </div>
    </motion.div>
  );
};
